//src/pages/REG/REG300F1.jsx

import React, {useContext, useEffect, useState, useRef} from 'react';
import style from "./REG300F1.module.scss";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";

import Render1Html from './REG300F2';
import Render2Html from './REG300F3';
import Render3Html from './REG300F4';
import Render4Html from './REG300F5';
import Render5Html from './REG300F6';
import Render6Html from './REG300F7';
import {postData} from 'utils/TransactionUtil';
import styleCom from "./REGCOM.module.scss";
import Modal from "components/Modal/Modal";
import REG300M1 from "./REG300M1"; //자동쿼리
import REG300M2 from "./REG300M2"; //수동쿼리
import regJson from 'assets/json/frmReg_data.json';
import {AuthContext} from "../../contexts/AuthContext";
import {MenuContext} from "../COM/COM001L1";


/* TAB 구성 */
function Sidebar({ tabs, activeTabId, onTabClick }) {
    return (
        <ul className={style.tabList}>
            {tabs.map((tab) => (
                <li key={tab.id} className={`${style.tabItem} ${activeTabId === tab.id ? style.activeTab : ''}`}
                    onClick={() => onTabClick(tab.id)}
                >
                    {tab.label}
                </li>
            ))}
        </ul>
    );
}


/* ************************************************************************************
*************************************************************************************** */

const REG300F1 = ({navBar: NavBar, mstId, hsptCd, colKey}) => {
    const [workId, setWorkId] = useState(mstId);
    const [workHsptCd, setWorkHsptCd] = useState(hsptCd);
    const [workStartPage, setWorkStartPage] = useState(colKey);

    const [dsOgMst,setDsOgMst] = useState([]);
    const [dsOgDtl,setDsOgDtl] = useState([]);
    const [dsMst,setDsMst] = useState([]);
    const [dsDtl,setDsDtl] = useState([]);

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [isHasPermission, setIsHasPermission] = useState(
        (userInfo.roleId === '100001' || userInfo.roleId === '300001')
    );

    const [isModalOpen, setIsModalOpen] = useState(false); //모달 오픈여부
    const [isModalOpen_manual, setIsModalOpen_manual] = useState(false); //모달 오픈여부
    const { addPage_manual } = useContext(MenuContext);

    const dtlObj = [
        { name: 'mstId', value: ''},
        { name: 'hsptCd', value: ''},
        { name: 'subjectSno', value: ''}

    ];

    const activeFlagObj = regJson.activeFlagObj;

    //폼 로드
    useEffect(() => {
        svcSubjectData(workId).then(() => {
        });
    }, []);

    //AUTO Query 체크

    const [autoCheckObj, setAutoCheckObj] = useState([]);

/* Call Service ****************************************************************************** */
    async function svcGetComItem() {
        let param = {

        }
        let result = await postData("/RED/getWorkInitData", param);
        setDsOgMst(result.outDsInitMst);
        setDsOgDtl(result.outDsInitDtl);

    }
    async function svcSubjectData() {
        let param = {
             mstId:workId
            ,hsptCd:workHsptCd
        }
        let result = await postData("/RED/getSubjectData", param);
        setDsMst(result.outDs1);
        setDsDtl(result.outDs2);

        //activeEvent
        result.outDs2.forEach(item => {
            initialItemState(item.mapCd, item.itmRslt);
        });


        //Subject list 에서 페이지 선택시 해당 탭으로 연결
        let startTab = "";
        switch (workStartPage) {
            case "task1Stat"  : startTab = "T1";  break;
            case "task12Stat" : startTab = "T12"; break;
            case "task2Stat"  : startTab = "T2";  break;
            case "task3Stat"  : startTab = "T3";  break;
            case "task4Stat"  : startTab = "T4";  break;
            case "task5Stat"  : startTab = "T5";  break;
            case "task6Stat"  : startTab = "T6";  break;
            case "task7Stat"  : startTab = "T7";  break;
            case "task8Stat"  : startTab = "T8";  break;
            case "task9Stat"  : startTab = "T9";  break;
            case "task10Stat" : startTab = "T10" ;  break;
            case "task11Stat" : startTab = "T11" ;  break;
            case "task13Stat" : startTab = "T13" ;  break;
            case "task99Stat" : startTab = "T99" ;  break;

            default: startTab = "T0" ; break;
        }
        setActiveTabId(startTab);


    } 

    const svcSaveData = async (dsMstCopy) => {

        const mstParam = dsMstCopy;
        const dtlParam = dsDtl.filter(item => item.itmRslt !== null && item.itmRslt !== "");
        const paramList = {
            mstParam: mstParam,
            dtlParam: dtlParam
        };

        let result = await postData("/RED/saveSubjectData", paramList);


    }

    //데이터 셋팅 및 유효성 검사
    const prepareSaveQuality = () => {
        let valid = "";
        /* 탭 구분: T1 | 항목구분코드(추후 카테고리코드 사용) | 항목명 | MapCd 1,2,3...
        * 오브젝트를 기준으로 값을 체크 하고, 상태값 처리를함
        */



        return  valid;
    };

/* ****************************************************************************** Call Service */


/* User Function ****************************************************************************** */

    //데이터 get, set
    const getMstValue = (colName) =>{
        const targetItem = dsMst.find(item => item.mstId === workId);
        if (targetItem && targetItem.hasOwnProperty(colName)) {
            return targetItem[colName];
        } else {
            return ""; // 또는 다른 적절한 값 (null, 에러 처리 등)
        }
    }
    const setMstValue = (colName, newValue) => {
        setDsMst(prevData =>
            prevData.map(item =>
                item.mstId === workId? { ...item, [colName]:newValue } : item
            )
        );
    };
    //데이터 get, set
    const getDtlValue = (mapCd, colName='itmRslt') =>{
        const targetItem = dsDtl.find(item => item.mapCd === mapCd);
        if (targetItem && targetItem.hasOwnProperty(colName)) {
            return targetItem[colName];
        } else {
            return ""; // 또는 다른 적절한 값 (null, 에러 처리 등)
        }
    }
    const setDtlValue = (mapCd, newValue, colName='itmRslt') => {
        setDsDtl(prevData =>
            prevData.map(item =>
                item.mapCd === mapCd? { ...item, [colName]:newValue } : item
            )
        );

    };

    const initialItemState = (mapCd, value="") =>{

        const matchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='matched' && item.chkVal === value
        );
        const notMatchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='notMatched'
        );

        if(matchedObj.length > 0){
            matchedObj.forEach(item => {
                if(matchedObj.length > 0 && item.chkVal === value){
                    setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                }
            });
        }else if(notMatchedObj.length > 0){
            // if(mapCd==='M00010'){
            //     console.log(mapCd + " : ");
            // }

            notMatchedObj.forEach(item => {
                setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                // if(item.mapCd ==='M00010'){
                //     console.log("수행");
                //     console.log(item.tarFlag);
                // }
            });
        }

    }

    const formatDate = (dateString) => {
        return `${dateString.slice(0, 4)}-${dateString.slice(4, 6)}-${dateString.slice(6, 8)}`;
    };

    const getStatDisplay = (statCd) =>{
        let resultStat = '';
        switch (statCd) {
            case 'A':  resultStat = '🔴';  break;
            case 'B':  resultStat = '🔵';  break;
            case 'C':  resultStat = '🟢';  break;
            default:
                break;
        }

        return resultStat;
    }


    //Tab 구성
    let stat1 = getStatDisplay(getMstValue('task1Stat'));
    let stat12 = getStatDisplay(getMstValue('task12Stat'));
    let stat2 = getStatDisplay(getMstValue('task2Stat'));
    let stat3 = getStatDisplay(getMstValue('task3Stat'));
    let stat4 = getStatDisplay(getMstValue('task4Stat'));
    let stat5 = getStatDisplay(getMstValue('task5Stat'));
    let stat6 = getStatDisplay(getMstValue('task6Stat'));
    let stat7 = getStatDisplay(getMstValue('task7Stat'));
    let stat8 = getStatDisplay(getMstValue('task8Stat'));
    let stat9 = getStatDisplay(getMstValue('task9Stat'));
    let stat10 = getStatDisplay(getMstValue('task10Stat'));
    let stat11 = getStatDisplay(getMstValue('task11Stat'));
    let stat13 = getStatDisplay(getMstValue('task13Stat'));
    let stat99 = getStatDisplay(getMstValue('task99Stat'));

    const tabs = [
        { id: 'T0', label: 'Demographics', content: 'Demographics Content Here' },
        { id: 'T1', label: (stat1  + ' Admission'), content: 'Admission Content Here' },
        { id: 'T12',label: (stat12 + ' Lab Data'), content: 'Lab Data Content Here'},
        { id: 'T2', label: (stat2  + ' CAG'), content: 'CAG Content Here' },
        { id: 'T3', label: (stat3  + ' 1st Lesion'), content: '1st Lesion Content Here' },
        { id: 'T4', label: (stat4  + ' 2nd Lesion'), content: '2nd Lesion Content Here' },
        { id: 'T5', label: (stat5  + ' 3rd Lesion'), content: '3rd Lesion Content Here' },
        { id: 'T6', label: (stat6  + ' 4th Lesion'), content: '4th Lesion Content Here' },
        { id: 'T7', label: (stat7  + ' Discharge'), content: 'Discharge Content Here' },
        { id: 'T8', label: (stat8  + ' 1M FU'), content: '1th FU Content Here' },
        { id: 'T9', label: (stat9  + ' 6M FU'), content: '6th FU Content Here' },
        { id: 'T10',label: (stat10 + ' 12M FU'), content: '12th FU Content Here' },
        { id: 'T11',label: (stat11 + ' FU Angiography'), content: 'FU Angiography Content Here' },
        { id: 'T13',label: (stat13 +' Clinical Event'), content: 'Clinical Event Content Here' },
        { id: 'T99',label: (stat99 + ' End of Study'), content: 'End of Study Content Here' }
    ];


    // 상태값 체크 *******************
    const stateItemObj = regJson.stateItemObj;

    //const stateResultObj = [
    const resultObj = [
         { contentId: 'T1',  checkState: '' }
        ,{ contentId: 'T2',  checkState: '' }
        ,{ contentId: 'T3',  checkState: '' }
        ,{ contentId: 'T4',  checkState: '' }
        ,{ contentId: 'T5',  checkState: '' }
        ,{ contentId: 'T6',  checkState: '' }
        ,{ contentId: 'T7',  checkState: '' }
        ,{ contentId: 'T8',  checkState: '' }
        ,{ contentId: 'T9',  checkState: '' }
        ,{ contentId: 'T10', checkState: '' }
        ,{ contentId: 'T11', checkState: '' }
        ,{ contentId: 'T12', checkState: '' }
        ,{ contentId: 'T13', checkState: '' }
    ];

    const updateWorkState = () => {

        // dsMst 복사본 만들기 (깊은 복사, 필요한 깊이만큼)
        const dsMstCopy = dsMst.map(item => ({ ...item }));

        // 내부 함수: setMstValue_new처럼 dsMstCopy 수정
        const setMstValue_new = (colName, newValue) => {
          for (let item of dsMstCopy) {
            if (item.mstId === workId) {
              item[colName] = newValue;
              break;
            }
          }
        };

        const getMstValue_new = (colName) => {
          const target = dsMstCopy.find(item => item.mstId === workId);
          return target && target.hasOwnProperty(colName) ? target[colName] : "";
        };


        const updatedStatusObj = stateItemObj.map((row) => {
            const { contentId, chkItem } = row; // 💡 인자로 id와 item만 받도록 깔끔하게 변경!

            // 값이 존재하고(not empty/undefined), 동시에 숫자와 마침표 패턴인지 검사
            const isNumericStr = (val) => {
                if (!val) return false; // '', undefined, null은 여기서 바로 false 반환!
                return /^[0-9.]+$/.test(val);
            };


            //내부 체크로직 검사함수
            const chkItemHasOne = (id, item) => {
                // 주 키가 일치하지 않으면 검사할 필요도 없이 false
                if (contentId !== id || chkItem !== item) return false;
                const mcdKeys = [ 'mcd_01', 'mcd_02', 'mcd_03', 'mcd_04', 'mcd_05'
                    ,'mcd_06', 'mcd_07', 'mcd_08', 'mcd_09', 'mcd_10'
                    ,'mcd_11', 'mcd_12', 'mcd_13', 'mcd_14', 'mcd_15'];

                return mcdKeys.some(key => {
                    const mcdValue = row[key]; // 💡 바깥의 row를 그대로 가져와 씁니다.

                    if (mcdValue === "") return false; // 빈 값이면 패스

                    const realValue = getDtlValue(mcdValue);
                    return realValue && realValue.includes('1');
                });
            };
            //contentId,chkItem 기준 체크박스에서 몇개가 선택되었는지 값을 체크하기 위한용도
            const getChkItemMatchCount = (id, item) => {

                // 주 키가 일치하지 않으면 애초에 만족하는 개수가 0개이므로 0 반환
                if (contentId !== id || chkItem !== item) return 0;

                const mcdKeys = [ 'mcd_01', 'mcd_02', 'mcd_03', 'mcd_04', 'mcd_05'
                    ,'mcd_06', 'mcd_07', 'mcd_08', 'mcd_09', 'mcd_10'
                    ,'mcd_11', 'mcd_12', 'mcd_13', 'mcd_14', 'mcd_15'];
                let matchCount = 0;

                for (const key of mcdKeys) {
                    const mcdValue = row[key];

                    if (mcdValue !== "") {
                        const realValue = getDtlValue(mcdValue);

                        if (realValue && realValue.includes('1')) {
                            matchCount++;
                        }
                    }
                }
                // true/false 대신, 카운트 결과 반환
                return matchCount;
            };


            // @param {Object} codeObj - { 코드1, 코드2, 코드3.. }
            //  DTL 아이템중 값이 존재하는 아이템 카운트
            const getActiveDtlValueCount = (codeObj = {}) => {
                // 객체의 value들(진짜 코드값들)만 뽑아서 배열로 만듭니다.
                const codes = Object.values(codeObj);

                return codes.filter(code => {
                    // 코드값을 펑션에 태워 실제 데이터를 추출 후 검증
                    const realValue = getDtlValue(code);
                    return !!realValue;
                }).length;
            };

            // [예외 조건 추가]
            // 관리번호 : A0024  요청일 : 2026-06-16
            // FU angiography탭 항목들의 값이 'Not done'이면 나머지 항목들은 체크 패스
            if (getDtlValue("M09001") === '2' && row.contentId === 'T11') {
                return { ...row, isChecked: true };
            }

            // 관리번호 : A0025  요청일 : 2026-06-16
            // End of Study 임상연구 종료의 임상연구 완료여부가 중도탈락일 경우만 중도 탈락사유 아이템 체크
            if (getMstValue("studyEndStat") !== '3'
              && row.contentId === 'T99' && row.chkItem === 'I003') {
                return { ...row, isChecked: true };
            }

            /* 아이템 체크 상세 체크 로직 추가
            *  2026-06-22
            * */
            if (row.contentId === 'T1' && row.chkItem === 'I028' && getDtlValue("M00002") !== '10') {
                return { ...row, isChecked: true };
            }
            //
            if(row.contentId === 'T1' && row.chkItem === 'I029' && getDtlValue("M00010") === '1') {
                if(chkItemHasOne('T1','I029')){
                    return { ...row, isChecked: true };
                }else{

                    return { ...row, isChecked: false };
                }
            }else if(row.contentId === 'T1' && row.chkItem === 'I029'){
                return { ...row, isChecked: true };
            }
            //
            if (row.contentId === 'T1' && row.chkItem === 'I030' && getDtlValue("M00024") !== '1') {
                return { ...row, isChecked: true };
            }
            //
            if (   row.contentId === 'T1' && (['I031', 'I032', 'I033', 'I034'].includes(row.chkItem))
              && getDtlValue("M00032") !== '1') {
                return {...row, isChecked: true};
            }else{
                if(row.contentId === 'T1' && row.chkItem === 'I032' && getDtlValue("M00033") !== '2'){
                    return {...row, isChecked: true};
                }else if(row.contentId === 'T1' && row.chkItem === 'I032' && getDtlValue("M00033") === '2'){
                    return {...row, isChecked: chkItemHasOne("T1","I032")};
                }
                if(row.contentId === 'T1' && row.chkItem === 'I033' && getDtlValue("M00033") !== '3'){
                    return {...row, isChecked: true};
                }else if(row.contentId === 'T1' && row.chkItem === 'I033' && getDtlValue("M00033") === '3'){
                    return {...row, isChecked: chkItemHasOne("T1","I033")};
                }
                if(row.contentId === 'T1' && row.chkItem === 'I034' && getDtlValue("M00033") !== '4'){
                    return {...row, isChecked: true};
                }

            }
            if (row.contentId === 'T1' && row.chkItem === 'I035' && getDtlValue("M00042") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T1' && row.chkItem === 'I036' && getDtlValue("M00043") !== '6') {
                return { ...row, isChecked: true };
            }


            //Lab data 체크로직 추가
            if (row.contentId === 'T12' && row.chkItem === 'I041'
              && (!isNumericStr(getDtlValue("M10027")) && getDtlValue("M10027") === 'ND')) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T12' && row.chkItem === 'I042'
              && (!isNumericStr(getDtlValue("M10029")) && getDtlValue("M10029") === 'ND')) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T12' && row.chkItem === 'I043'
              && (!isNumericStr(getDtlValue("M10031")) && getDtlValue("M10031") === 'ND')) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T12' && row.chkItem === 'I044'
              && (!isNumericStr(getDtlValue("M10033")) && getDtlValue("M10033") === 'ND')) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T12' && row.chkItem === 'I045' && getDtlValue("M10043") !== '1') {
                return { ...row, isChecked: true };
            }

            //CAG 체크로직
            if (row.contentId === 'T2' && row.chkItem === 'I014' && getDtlValue("M11009") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T2' && row.chkItem === 'I015' && getDtlValue("M11026") !== '1') {
                return { ...row, isChecked: true };
            }
            if ((row.contentId === 'T2' && row.chkItem === 'I016' && getDtlValue("M11040") !== '1')) {
                return {...row, isChecked: true};
            }
            if ((row.contentId === 'T2' && row.chkItem === 'I017' && getDtlValue("M11040") !== '2')) {
                return {...row, isChecked: true};
            }else if ((row.contentId === 'T2' && row.chkItem === 'I017' && getDtlValue("M11040") === '2')) {
                if(getChkItemMatchCount('T2','I017') >= 2 ) {
                    return {...row, isChecked: true};
                }else{
                    return {...row, isChecked: false};
                }
            }
            if (row.contentId === 'T2' && row.chkItem === 'I018' && getDtlValue("M11040") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T2' && row.chkItem === 'I019' && getDtlValue("M11048") !== '1') {
                return { ...row, isChecked: true };
            }

            //1st Lesion
            if (row.contentId === 'T3' && ['I017', 'I018', 'I019'].includes(row.chkItem)
              && Number(getDtlValue("M01028")) < 1) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T3' && ['I034', 'I035', 'I036'].includes(row.chkItem)
              && Number(getDtlValue("M01028")) < 2) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T3' && ['I037', 'I038', 'I039'].includes(row.chkItem)
              && Number(getDtlValue("M01028")) < 3) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T3' && ['I040', 'I041', 'I042'].includes(row.chkItem)
              && Number(getDtlValue("M01028")) < 4) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T3' && ['I043', 'I044', 'I045'].includes(row.chkItem)
              && Number(getDtlValue("M01028")) < 5) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T3' && row.chkItem === 'I046' && getDtlValue("M01052") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T3' && row.chkItem === 'I047' && getDtlValue("M01053") !== '3') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T3" && ['I048', 'I049'].includes(row.chkItem)
              && getDtlValue("M01057") !=="2") {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T3' && row.chkItem === 'I050' && getDtlValue("M01061") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T3' && row.chkItem === 'I051' && getDtlValue("M01069") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T3' && row.chkItem === 'I052' && getDtlValue("M01052") !=="2") {
                return { ...row, isChecked: true };
            }

            //2nd Lesion
            if (row.contentId === "T4" && ['I017', 'I018', 'I019'].includes(row.chkItem)
              && Number(getDtlValue("M02028")) < 1) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T4" && ['I034', 'I035', 'I036'].includes(row.chkItem)
              && Number(getDtlValue("M02028")) < 2) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T4" && ['I037', 'I038', 'I039'].includes(row.chkItem)
              && Number(getDtlValue("M02028")) < 3) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T4" && ['I040', 'I041', 'I042'].includes(row.chkItem)
              && Number(getDtlValue("M02028")) < 4) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T4" && ['I043', 'I044', 'I045'].includes(row.chkItem)
              && Number(getDtlValue("M02028")) < 5) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T4" && row.chkItem === 'I046' && getDtlValue("M02052") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T4" && row.chkItem === 'I047' && getDtlValue("M02053") !== '3') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T4" && ['I048', 'I049'].includes(row.chkItem)
              && getDtlValue("M02057") !=="2") {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T4" && row.chkItem === 'I050' && getDtlValue("M02061") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T4" && row.chkItem === 'I051' && getDtlValue("M02069") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T4' && row.chkItem === 'I052' && getDtlValue("M02052") !=="2") {
                return { ...row, isChecked: true };
            }

            //3rd Lesion
            if (row.contentId === "T5" && ['I017', 'I018', 'I019'].includes(row.chkItem)
              && Number(getDtlValue("M03028")) < 1) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T5" && ['I034', 'I035', 'I036'].includes(row.chkItem)
              && Number(getDtlValue("M03028")) < 2) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T5" && ['I037', 'I038', 'I039'].includes(row.chkItem)
              && Number(getDtlValue("M03028")) < 3) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T5" && ['I040', 'I041', 'I042'].includes(row.chkItem)
              && Number(getDtlValue("M03028")) < 4) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T5" && ['I043', 'I044', 'I045'].includes(row.chkItem)
              && Number(getDtlValue("M03028")) < 5) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T5" && row.chkItem === 'I046' && getDtlValue("M03052") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T5" && row.chkItem === 'I047' && getDtlValue("M03053") !== '3') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T5" && ['I048', 'I049'].includes(row.chkItem)
              && getDtlValue("M03057") !=="2") {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T5" && row.chkItem === 'I050' && getDtlValue("M03061") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T5" && row.chkItem === 'I051' && getDtlValue("M03069") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T5' && row.chkItem === 'I052' && getDtlValue("M03052") !=="2") {
                return { ...row, isChecked: true };
            }

            //4th Lesion
            if (row.contentId === "T6" && ['I017', 'I018', 'I019'].includes(row.chkItem)
              && Number(getDtlValue("M04028")) < 1) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T6" && ['I034', 'I035', 'I036'].includes(row.chkItem)
              && Number(getDtlValue("M04028")) < 2) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T6" && ['I037', 'I038', 'I039'].includes(row.chkItem)
              && Number(getDtlValue("M04028")) < 3) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T6" && ['I040', 'I041', 'I042'].includes(row.chkItem)
              && Number(getDtlValue("M04028")) < 4) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T6" && ['I043', 'I044', 'I045'].includes(row.chkItem)
              && Number(getDtlValue("M04028")) < 5) {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T6" && row.chkItem === 'I046' && getDtlValue("M04052") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T6" && row.chkItem === 'I047' && getDtlValue("M04053") !== '3') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T6" && ['I048', 'I049'].includes(row.chkItem)
              && getDtlValue("M04057") !=="2") {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T6" && row.chkItem === 'I050' && getDtlValue("M04061") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T6" && row.chkItem === 'I051' && getDtlValue("M04069") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === 'T6' && row.chkItem === 'I052' && getDtlValue("M04052") !=="2") {
                return { ...row, isChecked: true };
            }

            //Discharge
            if (row.contentId === "T7" && row.chkItem === 'I021' && getDtlValue("M05001") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I022' && getDtlValue("M05003") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I023' && getDtlValue("M05010") !== '4') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I024' && getDtlValue("M05011") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I025' && getDtlValue("M05013") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I026' && getDtlValue("M05016") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I027' && getDtlValue("M05011") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I028' && getDtlValue("M05021") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I029' && getDtlValue("M05026") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I030' && getDtlValue("M05027") !== '4') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I031' && getDtlValue("M05036") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I032' && getDtlValue("M05037") !== '6') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I033' && getDtlValue("M05027") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T7" && row.chkItem === 'I034' && getDtlValue("M05027") !== '3') {
                return { ...row, isChecked: true };
            }


            //FU-1M
            if (row.contentId === "T8" && ['I019', 'I020'].includes(row.chkItem) && getDtlValue("M06001") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I021' && getDtlValue("M06001") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I022' && getDtlValue("M06004") !== '3') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I023' && getDtlValue("M06006") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I024' && getDtlValue("M06007") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I025' && getDtlValue("M06009") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I026' && getDtlValue("M06015") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I027' && getDtlValue("M06022") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I028' && getDtlValue("M06023") !== '4') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I029' && getDtlValue("M06032") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I030' && getDtlValue("M06033") !== '6') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I031'
              && [getDtlValue("M06052"),getDtlValue("M06053"),getDtlValue("M06054"),getDtlValue("M06055")
                  ,getDtlValue("M06056"),getDtlValue("M06057"),getDtlValue("M06058"),getDtlValue("M06059")
                  ,getDtlValue("M06060"),getDtlValue("M06061"),getDtlValue("M06062")].every(item => item === 'ND')){
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I043' && getDtlValue("M06023") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T8" && row.chkItem === 'I044' && getDtlValue("M06023") !== '3') {
                return { ...row, isChecked: true };
            }


            //FU-6M
            if (row.contentId === "T9" && ['I019', 'I020'].includes(row.chkItem) && getDtlValue("M07001") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I021' && getDtlValue("M07001") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I022' && getDtlValue("M07004") !== '3') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I023' && getDtlValue("M07006") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I024' && getDtlValue("M07007") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I025' && getDtlValue("M07009") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I026' && getDtlValue("M07015") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I027' && getDtlValue("M07022") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I028' && getDtlValue("M07023") !== '4') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I029' && getDtlValue("M07032") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I030' && getDtlValue("M07033") !== '6') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I031'
              && [getDtlValue("M07052"),getDtlValue("M07053"),getDtlValue("M07054"),getDtlValue("M07055")
                  ,getDtlValue("M07056"),getDtlValue("M07057"),getDtlValue("M07058"),getDtlValue("M07059")
                  ,getDtlValue("M07060"),getDtlValue("M07061"),getDtlValue("M07062")].every(item => item === 'ND')){
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I043' && getDtlValue("M07023") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T9" && row.chkItem === 'I044' && getDtlValue("M07023") !== '3') {
                return { ...row, isChecked: true };
            }

            //FU-12M
            if (row.contentId === "T10" && ['I019', 'I020'].includes(row.chkItem) && getDtlValue("M08001") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I021' && getDtlValue("M08001") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I022' && getDtlValue("M08004") !== '3') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I023' && getDtlValue("M08006") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I024' && getDtlValue("M08007") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I025' && getDtlValue("M08009") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I026' && getDtlValue("M08015") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I027' && getDtlValue("M08022") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I028' && getDtlValue("M08023") !== '4') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I029' && getDtlValue("M08032") !== '1') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I030' && getDtlValue("M08033") !== '6') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I031'
              && [getDtlValue("M08052"),getDtlValue("M08053"),getDtlValue("M08054"),getDtlValue("M08055")
                  ,getDtlValue("M08056"),getDtlValue("M08057"),getDtlValue("M08058"),getDtlValue("M08059")
                  ,getDtlValue("M08060"),getDtlValue("M08061"),getDtlValue("M08062")].every(item => item === 'ND')){
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I043' && getDtlValue("M08023") !== '2') {
                return { ...row, isChecked: true };
            }
            if (row.contentId === "T10" && row.chkItem === 'I044' && getDtlValue("M08023") !== '3') {
                return { ...row, isChecked: true };
            }

            //FU Angiography
            if (row.contentId === "T11" && row.chkItem === 'I011' && getDtlValue("M09007") !== '1') {
                return { ...row, isChecked: true };
            }

            //Clinical Event
            // 별도 예외처리([요청:A0022]수정요청에 의하여 2026-03-05 추가함) :
            //  - Clinical Event 이상반응-1 종료일의 경우 결과 > 결과 상태값이 3,4,6 일때는 체크하지 않음
            if (row.contentId === "T13") {
                // chkItem과 매칭되는 상세 ID 맵핑
                const targetMap = {
                    I003: "M12010", I103: "M12021", I203: "M12032", I303: "M12043", I403: "M12054",
                };

                const dtlKey = targetMap[row.chkItem];

                // 해당 chkItem이 존재하고, 값이 ['3', '4', '6']에 포함되는 경우
                if (dtlKey && ['3', '4', '6'].includes(getDtlValue(dtlKey))) {
                    return { ...row, isChecked: true };
                }
            }


            if (row.contentId === "T13"
              && ["I101","I102","I103","I104","I105","I106","I107","I108","I109","I110","I111"].includes(row.chkItem)){
                if(getActiveDtlValueCount([ "M12012","M12013","M12014","M12015","M12016","M12017"
                    ,"M12018","M12019","M12020","M12021","M12022"]) <= 0 ) {
                    return {...row, isChecked: true};
                }
            }
            if (row.contentId === "T13"
              && ["I201","I202","I203","I204","I205","I206","I207","I208","I209","I210","I211"].includes(row.chkItem)){
                if(getActiveDtlValueCount([ "M12023","M12024","M12025","M12026","M12027","M12028"
                    ,"M12029","M12030","M12031","M12032","M12033"]) <= 0 ) {
                    return {...row, isChecked: true};
                }
            }
            if (row.contentId === "T13"
              && ["I301","I302","I303","I304","I305","I306","I307","I308","I309","I310","I311"].includes(row.chkItem)){
                if(getActiveDtlValueCount([ "M12034","M12035","M12036","M12037","M12038","M12039"
                    ,"M12040","M12041","M12042","M12043","M12044"]) <= 0 ) {
                    return {...row, isChecked: true};
                }
            }
            if (row.contentId === "T13"
              && ["I401","I402","I403","I404","I405","I406","I407","I408","I409","I410","I411"].includes(row.chkItem)){
                if(getActiveDtlValueCount([ "M12045","M12046","M12047","M12048","M12049","M12050"
                    ,"M12051","M12052","M12053","M12054","M12055"]) <= 0 ) {
                    return {...row, isChecked: true};
                }
            }

            //End Of Study
            if (row.contentId === "T99" && row.chkItem === 'I003' && getMstValue_new('studyEndStat') !=='3') {
                return { ...row, isChecked: true };
            }



            // mcd 필드만 추출
            const mcdKeys = Object.keys(row).filter((key) => key.startsWith('mcd_'));
            // 조건에 따라 isChecked 계산
            // Clinical Event의 studyEndDt, studyEndStat, signatureNm, dropReasonStat 의 경우 MST 데이터필요
            // DTL 데이터와 코드방식이 달라서 필드명으로 구분함
            const isChecked = mcdKeys.some((key) => {
                const rawMapCd = row[key];
                if (!rawMapCd) return false;

                let val = "";
                if (['studyEndDt', 'studyEndStat', 'signatureNm','dropReasonStat'].includes(rawMapCd)) {
                    val = getMstValue(rawMapCd);
                } else {
                    val = getDtlValue(rawMapCd);
                }

                return !!val && val !== '0';    //최종 값 검사 (val이 존재하고 '0'이 아닐 때만 true)
            });

            // 1단계 결과 로그 출력
            // console.log(`✅ contentId: ${row.contentId}, chkItem: ${row.chkItem}, isChecked: ${isChecked}`);
            // console.log("contentId: " + row.contentId);


            // if(row.contentId==="T98"){
            //     console.log(`✅ contentId: ${row.contentId}, chkItem: ${row.chkItem}, isChecked: ${isChecked}`);
            // }

            // isChecked 필드 추가된 row 반환
            return { ...row, isChecked };
        });


        //체크리스트 상세내역 저장
        setAutoCheckObj(updatedStatusObj.filter(row => {
            if (getDtlValue('M02000') ==='1' && row.contentId === 'T4') return false;
            if (getDtlValue('M03000') ==='1'  && row.contentId === 'T5') return false;
            if (getDtlValue('M04000') ==='1'  && row.contentId === 'T6') return false;
            if (getDtlValue('M12000') ==='1'  && row.contentId === 'T13') return false;
            if (row.isChecked===true) return false;
            return true;
        }));

        // 그룹화: updatedStatusObj에서 contentId별로 묶기
        //const [grouped, setGrouped] = userState([]);
        const grouped = [];
        updatedStatusObj.forEach((row) => {
            if (!grouped[row.contentId]) grouped[row.contentId] = [];
            grouped[row.contentId].push(row);
        });
        // const addGroup = {contentId:""};
        // setGrouped([...grouped, addGroup]);



        // resultObj 업데이트: 비교값 없으면 '' 처리
        const updatedResultObj = resultObj.map((result) => {
            const groupRows = grouped[result.contentId];

            if(getDtlValue('M02000') === '1' && result.contentId === 'T4'){
                return { ...result, checkState: 'B'};
            }else if(getDtlValue('M03000') === '1' && result.contentId === 'T5'){
                return { ...result, checkState: 'B'};
            }else if(getDtlValue('M04000') === '1' && result.contentId === 'T6'){
                return { ...result, checkState: 'B'};
            }else if(getDtlValue('M12000') === '1' && result.contentId === 'T13'){
                return { ...result, checkState: 'B'};
            }else if (!groupRows || groupRows.length === 0) {
                //console.log(`contentId: ${result.contentId} → 비교할 row 없음 → checkState: ''`);
                return { ...result, checkState: ''};
            }


            const allTrue = groupRows.every((row) => row.isChecked === true);
            const checkState = allTrue ? 'C' : 'A';

            //console.log(`🔍 contentId: ${result.contentId} → checkState: ${checkState}`);
            return { ...result, checkState };
        });

        updatedResultObj.forEach(({ contentId, checkState }) => {
            switch (contentId) {
                case 'T1':   setMstValue_new('task1Stat', checkState);  break;
                case 'T12':  setMstValue_new('task12Stat', checkState); break;
                case 'T2':   setMstValue_new('task2Stat', checkState);  break;
                case 'T3':   setMstValue_new('task3Stat', checkState);  break;
                case 'T4':   setMstValue_new('task4Stat', checkState);  break;
                case 'T5':   setMstValue_new('task5Stat', checkState);  break;
                case 'T6':   setMstValue_new('task6Stat', checkState);  break;
                case 'T7':   setMstValue_new('task7Stat', checkState);  break;
                case 'T8':   setMstValue_new('task8Stat', checkState);  break;
                case 'T9':   setMstValue_new('task9Stat', checkState);  break;
                case 'T10':  setMstValue_new('task10Stat', checkState);  break;
                case 'T11':  setMstValue_new('task11Stat', checkState);  break;
                case 'T13':  setMstValue_new('task13Stat', checkState);  break;
                default:
                    //console.log(` [기타 그룹 ${contentId}] 상태: ${checkState}`);
                    // 필요하면 추가 case로 확장 가능
                    break;
            }

            //예외처리 Lesion
            if(getDtlValue('M02000')==='1'){
                setMstValue_new('task4Stat', "B")
            }
            if(getDtlValue('M03000')==='1'){
                setMstValue_new('task5Stat', "B")
            }
            if(getDtlValue('M04000')==='1'){
                setMstValue_new('task6Stat', "B")
            }

            //T99 추가로직
            if(    ( getMstValue_new('studyEndDt') !=='' && getMstValue_new('studyEndDt') !== null)
                && ( getMstValue_new('studyEndStat') !=='' && getMstValue_new('studyEndStat') !== null)
                && ( getMstValue_new('signatureYn') ==='Y'
                     && getMstValue_new('signatureYn') !== '' && getMstValue_new('signatureYn') !== null)
            ){
                setMstValue_new('task99Stat', "C")
            }else{
                setMstValue_new('task99Stat', "A")
            }

        });


        setDsMst(dsMstCopy);
        return dsMstCopy
    }


/* ****************************************************************************** User Function */


/* TabPage Area ****************************************************************************** */


    const [activeTabId, setActiveTabId] = useState(tabs[0]?.id || null);
    // 활성화된 탭의 내용을 효율적으로 찾기 위해 useMemo 사용(activeTabId가 변경될 때만 다시 계산)
    
    //탭 클릭시 스크롤 제일 위로 처리
    const contentRef = useRef(null);
    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollTop = 0;
        }
    }, [activeTabId]);


    // 탭 클릭 핸들러
    const handleTabClick = (tabId) => {
        setActiveTabId(tabId);

    };


    function mainContent(contentId) {

        switch (contentId) {
            case "T0": case "T1": case "T2": case "T12":
                return (
                    <Render1Html contentId={contentId}     activeFlagObj={activeFlagObj}
                                 getMstValue={getMstValue} setMstValue={setMstValue}
                                 getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T3": case "T4": case "T5": case "T6":
                return (
                    <Render2Html contentId={contentId}     activeFlagObj={activeFlagObj} initialItemState={initialItemState}
                                 getMstValue={getMstValue} setMstValue={setMstValue}
                                 getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T7":
                return (
                    <Render3Html contentId={contentId}     activeFlagObj={activeFlagObj}
                                 getMstValue={getMstValue} setMstValue={setMstValue}
                                 getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T8":case "T9":case "T10":
                return (
                    <Render4Html contentId={contentId}     activeFlagObj={activeFlagObj}
                                 getMstValue={getMstValue} setMstValue={setMstValue}
                                 getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T11": case "T13":
                return (
                    <Render5Html contentId={contentId}     activeFlagObj={activeFlagObj}
                                 getMstValue={getMstValue} setMstValue={setMstValue}
                                 getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T99":
                return (
                    <Render6Html contentId={contentId}     activeFlagObj={activeFlagObj}
                                 getMstValue={getMstValue} setMstValue={setMstValue}
                                 getDtlValue={getDtlValue} setDtlValue={setDtlValue}
                                 updateWorkState={updateWorkState}
                    />

                );
            default:
                return null;
        }

    }


/* ****************************************************************************** TabPage Area */

/* Event ****************************************************************************** */
    const handleMainSave =  () =>  {
        if(isHasPermission===true){
            toast({ type: 'warning', message: '저장 권한이 없습니다.', opt: { position: "top-center"} });
            return;
        }else{

            const dsMstCopy = updateWorkState();  //상태값 체크
            svcSaveData(dsMstCopy).then(() => {
                toast({ type: 'success', message: '저장되었습니다.', opt: { position: "top-center"} });
            });
        }


    }

    const handleModalOpen = () => {
        updateWorkState();
        setIsModalOpen(true);
    }

    const handleModalOpen_manual = () => {
        setIsModalOpen_manual(true);
    }

    //사용자 상세 팝업 닫기
    const handleModal_Close = () => {
        //e.preventDefault();
        setIsModalOpen(false);
    }
    const handleModalClose_manual = () => {
        //e.preventDefault();
        setIsModalOpen_manual(false);
    }
/* ****************************************************************************** Event */




    return (
        <>
            <NavBar>
                {/*공통 영역*/}
                <div className={styleCom.search_wrap}>
                    <Button variant="Secondary" size="md" addStyle={{width: "110px", height: "40px"}}
                            onClick={()=> handleModalOpen()}>
                        Check Items
                    </Button>
                    <Button variant="Secondary" size="md" addStyle={{width: "110px", height: "40px"}}
                            onClick={()=> handleModalOpen_manual()}>
                        Manual Query
                    </Button>
                    <Button variant="Primary" size="md" addStyle={{width: "110px", height: "40px"}}
                            onClick={()=> handleMainSave()} >
                        저장
                    </Button>
                </div>
                {/*대상자 정보*/}
                <table className={style.info_table} style={{height: "42px", marginBottom:"-10px"}}>
                    <tbody>
                    <tr>
                        <td className={style.info_text_1}> Subject No.</td>
                        <td className={style.info_text_2}>{getMstValue("subjectCd")}</td>
                        <td>
                            <div className={style.verticalLine}/>
                        </td>

                        <td className={style.info_text_1}> Initial</td>
                        <td className={style.info_text_2}>{getMstValue("initial")}</td>
                        <td>
                            <div className={style.verticalLine}/>
                        </td>

                        <td className={style.info_text_1}> Sex/Age</td>
                        <td className={style.info_text_2}>{getMstValue("sex")}/{getMstValue("age")}</td>
                        <td>
                            <div className={style.verticalLine}/>
                        </td>
                        <td className={style.info_text_1}> PCI 시행일</td>
                        <td className={style.info_text_2}>{formatDate(getMstValue("pciDt"))}</td>

                    </tr>
                    </tbody>
                </table>
            </NavBar>
            <div className={styleCom.root_wrap}>

                {/*컨텐츠 영역*/}
                <div className={style.container}>
                    {/* 좌측 탭 목록 영역 */}
                    <div className={style.sidebar}>
                        <Sidebar
                            tabs={tabs}
                            activeTabId={activeTabId} // 활성화된 탭 ID 전달
                            onTabClick={handleTabClick} // 탭 클릭 핸들러 전달
                        />
                    </div>

                    {/* 우측 컨텐츠 영역 */}
                    <div ref={contentRef} className={style.contentArea} style={{width: "1300px"} }>
                        {mainContent(activeTabId)}
                    </div>
                </div>

            </div>
            <Modal
                open={isModalOpen}
                handle_Close={handleModal_Close}
                title="Auto Checklist"
                width ="1200px"
                height="800px"
                isHeader={true}
                isBottom={false}>
                <REG300M1 handle_Close={handleModal_Close} autoCheckObj={autoCheckObj} activeTabId={activeTabId} />
            </Modal>
            <Modal
                open={isModalOpen_manual}
                handle_Close={handleModalClose_manual}
                title="Manual Query"
                width ="1100px"
                height="800px"
                isHeader={true}
                isBottom={false}>
                <REG300M2 handle_Close={handleModalClose_manual} mstId={workId} hsptCd={workHsptCd}/>
            </Modal>
        </>


    );
};


export default REG300F1;
